var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8471 12.4975L8.94709 0.5475C8.52709 -0.1825 7.46709 -0.1825 7.03709 0.5475L0.147088 12.4975C-0.272912 13.2275 0.257088 14.1475 1.09709 14.1475H14.8971C15.7371 14.1475 16.2671 13.2275 15.8471 12.4975ZM8.69709 12.5375C8.30709 12.9275 7.66709 12.9175 7.28709 12.5275C6.89709 12.1275 6.89709 11.4975 7.29709 11.1075C7.68709 10.7175 8.32709 10.7275 8.70709 11.1175C9.08709 11.5075 9.09709 12.1475 8.69709 12.5375ZM9.07709 8.8275C9.03709 9.3875 8.56709 9.8275 7.99709 9.8275C7.42709 9.8275 6.96709 9.3975 6.91709 8.8275L6.62709 4.9775C6.58709 4.3575 7.07709 3.8175 7.70709 3.8175H8.28709C8.91709 3.8175 9.40709 4.3475 9.36709 4.9775L9.07709 8.8275Z",
    fill: "#FFAA04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarning);
export default __webpack_public_path__ + "static/media/alert-warning.b6b92ab17d140e2b2811aee2581348e0.svg";
export { ForwardRef as ReactComponent };